import { AnnouncementType, IAnnouncementModel } from '../../../interfaces/IAnnoucementModel';
import {
    GET_USER_ANNOUNCEMENTS_KEY,
    useGetUserAnnouncements,
} from '../../../pages/announcement/useGetUserAnnouncements';
import { useEffect, useState } from 'react';

import { AnnouncementDetail } from './AnnouncementDetail';
import { useLocation } from 'react-router-dom';
import { useQueryClient } from 'react-query';

export function GlobalAnnouncements() {
    const queryClient = useQueryClient();
    const location = useLocation();
    const userAnnouncementsQuery = useGetUserAnnouncements(!!location.pathname);
    const [globalAnnouncements, setGlobalAnnouncements] = useState<IAnnouncementModel[]>([]);

    const handleRemoveAnnouncement = (guid: string) => {
        queryClient.setQueryData(
            [GET_USER_ANNOUNCEMENTS_KEY],
            userAnnouncementsQuery?.data?.filter((f) => f.guid !== guid)
        );
    };

    useEffect(() => {
        setGlobalAnnouncements(
            userAnnouncementsQuery.data?.filter(
                (a) => a.announcementTypeId === AnnouncementType.Global
            ) ?? []
        );
    }, [location.pathname, userAnnouncementsQuery.data]);

    return (
        <>
            {globalAnnouncements.map((announcement: IAnnouncementModel) => {
                return (
                    <AnnouncementDetail
                        key={announcement.guid}
                        announcement={announcement}
                        onRemoveAnnouncement={handleRemoveAnnouncement}
                    />
                );
            })}
        </>
    );
}
